import Seo from '@/components/base/Seo';
import { faqItems } from '@/mocks/faq';
import { knowledgeSections } from './components/knowledgeHubContent';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import WhoIHelpSection from './components/WhoIHelpSection';
import ServicesSection from './components/ServicesSection';
import MethodSection from './components/MethodSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import KnowledgeHub from './components/KnowledgeHub';
import Footer from './components/Footer';

const HOME_TITLE = 'Energy-Safe Coaching for Pain & Fatigue | Healing & Breakthrough';
const HOME_DESCRIPTION =
  'The Energy-Safe Method from Healing & Breakthrough supports chronic illness, ADHD/Autism sensory drain and life-demand mismatch — breaking the Boom & Bust cycle with Energy-Safe Motions.';

// Single canonical FAQPage for the homepage: the FAQ accordion plus the 40
// knowledge-hub questions, merged so the page emits only one FAQPage block.
const HOME_FAQ_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  inLanguage: 'en-GB',
  mainEntity: [
    ...faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
    ...knowledgeSections.flatMap((section) =>
      section.questions.map((question) => ({
        '@type': 'Question',
        name: question.question,
        acceptedAnswer: { '@type': 'Answer', text: question.answer },
      }))
    ),
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        canonicalPath="/"
        jsonLd={HOME_FAQ_JSONLD}
      />
      <Navbar />
      <main>
        <HeroSection />
        <StorySection />
        <WhoIHelpSection />
        <ServicesSection />
        <MethodSection />
        <BeforeAfterSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
        <KnowledgeHub />
      </main>
      <Footer />
    </div>
  );
}